module.exports = __webpack_public_path__ + "media/images/flags/cx-d1447c4301e8093c812dbe2f861da0fc.svg";